<p-tabView (onChange)="handleTabChange($event)">
    <p-tabPanel header="Overview">
        <div class="arrow-steps">
            <div class="p-grid">
                <div class="p-col-12">
                    <ng-container *ngFor="let stage of rmaStages; let i = index">
                        <div class="step" (click)="changeStage(stage)" *ngIf="stage.isActive" [ngClass]="{
                                current:
                                    stage.id <= selectedReturn.selectedStageId,
                                handPointer:
                                    !editPermission
                            }" style="width:25%" (click)="changeStage(stage)">
                            <span>{{ stage.name }}</span>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="p-field p-formgrid p-grid">
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 150px">
                        <h6 class="p-mb-0">{{customerInformationLabel}}:</h6>
                        <p class="p-mb-0" *ngIf="customerInformation.businessName.show">
                            <span *ngIf="customerInformation?.sequenceNumber?.show">
                                {{ customerInformation?.sequenceNumber?.value && customerInformation?.sequenceNumber?.value?.length > 0 ? customerInformation?.sequenceNumber?.value + " - " : "" }}
                            </span> 
                            {{ customerInformation.businessName.value }}
                        </p>
                        <p class="p-mb-0" *ngIf="customerInformation.customerAddress1.show">
                            {{customerInformation.customerAddress1.value}}</p>
                        <p class="p-mb-0" *ngIf="customerInformation.customerAddress2.show">
                            {{customerInformation.customerAddress2.value}}</p>
                        <p class="p-mb-0" *ngIf="customerInformation.customerName.show">
                            {{customerInformation.customerName.value}}</p>
                        <p class="p-mb-0" *ngIf="customerInformation.phoneNumber.show">
                            {{customerInformation.phoneNumber.value}}</p>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <div class="p-fluid">
                    <div class="card" style="min-height: 150px">
                        <h6 class="p-mb-0">{{shippingLocationLabel}}:</h6>
                        <p class="p-mb-0" *ngIf="shippingLocation.businessName.show">
                            <span *ngIf="shippingLocation?.sequenceNumber?.show">
                                {{ shippingLocation?.sequenceNumber?.value && shippingLocation?.sequenceNumber?.value?.length > 0 ? shippingLocation?.sequenceNumber?.value + " - " : "" }}
                            </span> 
                            {{shippingLocation?.addressName?.value && shippingLocation?.addressName?.value?.length > 0 ?
                            shippingLocation?.addressName?.value : shippingLocation.businessName.value}}</p>
                        <p class="p-mb-0" *ngIf="shippingLocation.address1.show">{{shippingLocation.address1.value}}</p>
                        <p class="p-mb-0" *ngIf="shippingLocation.address2.show">{{shippingLocation.address2.value}}</p>
                        <p class="p-mb-0" *ngIf="shippingLocation.accountName.show">
                            {{shippingLocation.accountName.value}}</p>
                        <p class="p-mb-0" *ngIf="shippingLocation.phoneNumber.show">
                            {{shippingLocation.phoneNumber.value}}</p>
                        <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                            [customFieldData]="customFields.shipping_address_item">
                        </app-custom-attribute-overview>
                    </div>
                </div>
            </div>
            <div class="p-col-12 p-md-4">
                <ng-container *ngIf="isVisibleGenerateLabelOption">
                    <span class="btnBars p-mr-2" style="float: right" pTooltip="Create Shipping Label"
                        tooltipPosition="top" (click)="showShipmentDialog()">
                        <i class="pi pi-briefcase"></i>
                    </span>
                </ng-container>
                <div class="p-fluid">
                    <div class="card" style="min-height: 150px">
                        <div style="display: flex; align-items: center; justify-content: space-between; margin: 0; padding: 0;">
                            <h6 class="p-mb-0" style="margin: 0; padding: 0;">{{detailsLabel}}:</h6>
                            <button *ngIf="customerReturnDetails?.rmaStageId == 4 && customerRmaData.requestType.value == 'Credit' && !isAllowCreateCredit && customerReturnDetails?.creditStatusName != 'CreditCreated'" [disabled]="customerReturnDetails?.creditStatusName == 'CreditCreated'" type="button" pButton label="Create Credit"  class="p-button-secondary p-m-0" style="padding: 0.5rem; width: 120px;" (click)="createCredit()"></button>
                        </div>
                        <span class="btnBars p-mr-0" style="float: right;"
                            *ngIf="selectedReturn.selectedStageId == 5 && selectedReturn.type == 'Exchange'"
                            pTooltip="Create a new Sales Order" tooltipPosition="left">
                            <i class="pi pi-plus-circle"></i>
                        </span>
                        <span class="btnBars p-mr-0" style="float: right;"
                            *ngIf="selectedReturn.selectedStageId == 5 && selectedReturn.type == 'Credit'"
                            pTooltip="Create a new Credit Memo" tooltipPosition="left">
                            <i class="pi pi-plus-circle"></i>
                        </span>
                        <p class="p-mb-0" *ngIf="isAllowPostingPeriod">
                            <span>Posting Period:{{ customerReturnDetails?.postingDate  | date: 'MMMM yyyy' }}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="customerRmaData.rmaNumber.show">
                            RMA No.: <span>{{customerRmaData.rmaNumber.value}}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="customerRmaData.invoiceNo.show">
                            Invoice No.: <span>{{customerRmaData.invoiceNo.value}}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="customerRmaData.status.show">
                            RMA Status: <span>{{customerRmaData.status.value}}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="customerRmaData.requestType.show">
                            RMA Type: <span>{{customerRmaData.requestType.value}}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="customerReturnDetails?.rmaStageId == 4 && customerRmaData.requestType.value == 'Credit'">
                            Credit Status : <span>{{customerReturnDetails?.creditStatusName}}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="customerReturnDetails?.creditMemoNumber">
                            Credit Memo No.: <span>{{customerReturnDetails.creditMemoNumber}}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="customerRmaData.createdDate.show">
                            Created Date: <span>{{customerRmaData.createdDate.value | date: "MM/dd/yyyy"}}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="customerRmaData.location.show">
                            Location: <span>{{customerRmaData.location.value}}</span>
                        </p>
                        <p class="p-mb-0" *ngIf="customerRmaData.description.show">
                            Details: <span>{{customerRmaData.description.value}}</span>
                        </p>
                        <p class="p-mb-0">Currency: 1 {{baseCurrency?.code}} = {{customerReturnDetails?.exchangeRate}} {{customerReturnDetails?.account?.currencyUnit?.code }}</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="rmaProductList" styleClass="p-datatable-gridlines p-datatable-striped" dataKey="id">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 5rem"></th>
                            <ng-container *ngFor="let column of returnItemTable">
                                <th *ngIf="column.isChecked">
                                    {{column.labelname}}
                                </th>
                            </ng-container>
                            <th style="width: 3rem;"></th>
                            <!-- <th style="width: 3rem;">
                                <span class="btnBars p-mr-0">
                                    <i class="pi pi-plus"></i>
                                </span>
                            </th> -->
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>
                                <button type="button" pButton pRipple [pRowToggler]="product"
                                    class="p-button-text p-button-rounded p-button-plain"
                                    *ngIf="product.rmaBundleDetails?.length>0 && product.typeId!=6"
                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                            </td>
                            <ng-container *ngFor="let column of returnItemTable">
                                <td *ngIf="column.isChecked">
                                    <ng-container
                                        *ngIf="column.code == 'rate' || column.code == 'amount' || column.code == 'returnamt'; else displayData">
                                        {{product[column.code] | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : customerReturnDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits}}
                                    </ng-container>
                                    <ng-template #displayData>
                                        <span
                                            *ngIf="column.code == 'bin' && (product.typeId==1 || product.typeId==6)">{{product[column.code]}}</span>
                                        <span *ngIf="column.code != 'bin' && column.code != 'returnqty'">{{product[column.code] | shorten: 55}}</span>
                                        <span *ngIf="column.code == 'returnqty'">{{product[column.code] | customNumberFormat: qtyFractionDigits }}</span>
                                    </ng-template>
                                </td>
                            </ng-container>
                            <td>
                                <span class="btnBars p-mt-2 badge"
                                    *ngIf="product.typeId==1 && product.isTrackingEnabled"
                                    (click)="openScanInfo(product,'product')">
                                    <i class="pi pi-th-large" pBadge
                                        value="{{product.rmaProductSerialDetails ?product.rmaProductSerialDetails?.length: 0}}"
                                        severity="warning"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-product>
                        <!-- bundle Items -->
                        <tr *ngFor="let bd of product.rmaBundleDetails; let i = index" class="bundleRow">
                            <td></td>
                            <ng-container *ngFor="let column of rmaTemplate?.labels_table">
                                <td *ngIf="column.isChecked">
                                    <ng-container
                                        *ngIf="column.code == 'rate' || column.code == 'amount' || column.code == 'returnamt'; else displayData">
                                        {{bd[column.code] | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : customerReturnDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits}}
                                    </ng-container>
                                    <ng-template #displayData>
                                        <span *ngIf="column.code == 'bin' && bd.typeId==1">{{bd[column.code]}}</span>
                                        <span *ngIf="column.code != 'bin' && column.code != 'returnqty'">{{bd[column.code] | shorten: 55}}</span>
                                        <span *ngIf="column.code == 'returnqty'">{{bd[column.code] | customNumberFormat: qtyFractionDigits }}</span>
                                    </ng-template>
                                </td>
                            </ng-container>
                            <td>
                                <span class="btnBars p-mt-2 badge" *ngIf="bd.typeId==1 && bd.isTrackingEnabled"
                                    (click)="openScanInfo(bd,'bundle')">
                                    <i class="pi pi-th-large" pBadge
                                        value="{{bd.rmaBundleProductSerialDetail ? bd.rmaBundleProductSerialDetail?.length: 0}}"
                                        severity="warning"></i>
                                </span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="footer" let-product>
                        <tr *ngIf="rmaTemplate?.labels_footer[0]?.isChecked">
                            <td [attr.colspan]="footerColspan" class="p-text-right">
                                {{rmaTemplate?.labels_footer[0]?.labelname}}:</td>
                            <td colspan="2">{{subtotal | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : customerReturnDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits}}</td>
                        </tr>
                        <tr *ngIf="rmaTemplate?.labels_footer[1]?.isChecked">
                            <td [attr.colspan]="footerColspan" class="p-text-right">
                                {{rmaTemplate?.labels_footer[1]?.labelname}}:</td>
                            <td colspan="2">{{totalRefund | multicurrency: savedCurrencyExchangeRate ?? baseCurrency?.exchangeRate : customerReturnDetails?.account?.currencyUnit?.symbol ?? baseCurrency?.symbol : fractionDigits}}</td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
            <ng-container *ngIf="rmaAttachments.length > 0">
                <div class="p-col-12">
                    <p-table [value]="rmaAttachments" styleClass="p-datatable-gridlines p-datatable-striped">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Attachment Name</th>
                                <th>File</th>
                                <th>Download</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-attachment>
                            <tr>
                                <td>
                                    {{attachment.attachmentName}}
                                </td>
                                <td>
                                    <img class="rma-attachment" [src]="attachment.attachmentUrl" />
                                </td>
                                <td>
                                    <a [href]="attachment.attachmentUrl"><i class="pi pi-download"></i></a>
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
            </ng-container>
        </div>

        <!--Shipment Information-->
        <div *ngIf="rmaTemplate?.labels_message[3]?.isChecked">
            <div *ngFor="let d of customerReturnDetails?.rmaReturnShipment">
                <!-- Tracking No (Easypost,Ups,Fedex)-->
                <div class="p-col-12 p-md-12"
                    *ngIf="d?.statusId != '3' && d?.trackingLink != 'FEDEX' && d?.trackingLink != 'UPS'">
                    <span>Tracking No : {{ d?.trackingNo }}
                        <span class="btnBars p-mr-0"
                            *ngIf="(d?.deliveryStatus == 'pre_transit' || d?.deliveryStatus == '') && d?.statusId == '1'">
                            <i class="pi pi-times-circle" [pTooltip]="'Void Shipment'" (click)="voidShipment(d)"></i>
                        </span>
                    </span>
                </div>
                <div class="p-col-12 p-md-12" *ngIf="d?.statusId != '3' && d?.trackingLink == 'UPS'">
                    <span>Tracking No : {{ d?.trackingNo }}
                        <span class="btnBars p-mr-0" *ngIf="d?.statusId == '1'">
                            <i class="pi pi-times-circle" [pTooltip]="'Void Shipment'" (click)="voidShipment(d)"></i>
                        </span>
                    </span>
                </div>
                <div class="p-col-12 p-md-12" *ngIf="d?.statusId != '3' && d?.trackingLink == 'FEDEX'">
                    <span>Tracking No : {{ d?.trackingNo }}
                        <span class="btnBars p-mr-0" *ngIf="d?.statusId == '1'">
                            <i class="pi pi-times-circle" [pTooltip]="'Void Shipment'" (click)="voidShipment(d)"></i>
                        </span>
                    </span>
                </div>

                <!--Other Information-->
                <div class="p-col-12 p-md-12" *ngIf="d?.statusId == '2'"><span>{{ d?.refundStatus }}</span></div>
                <div class="p-col-12 p-md-12"
                    *ngIf="d?.statusId != '2' && d?.trackingLink != 'FEDEX' && d?.trackingLink != 'UPS'">
                    <span>Delivery Status :{{ d?.statusId == "3" ? "Voided" : d?.shipmentMessage }}</span>
                </div>
                <div class="p-col-12 p-md-12" *ngIf="d?.statusId == '3'"><span>Refund Status : {{ d?.refundStatus
                        }}</span></div>
                <div class="p-col-12 p-md-12"
                    *ngIf="d?.trackingLink && d?.trackingLink != 'FEDEX' && d?.trackingLink != 'UPS' && d?.statusId == '1' && d?.deliveryStatus != 'delivered'">
                    <span> <a href="{{ d?.trackingLink }}" target="_blank">Track order</a></span>
                </div>
                <div class="p-col-12 p-md-12"
                    *ngIf="d?.trackingLink && d?.trackingLink == 'FEDEX' && d?.statusId == '1'"><span>
                        <p>Delivery Status : {{ shipMessage }}</p>
                        <button type="button" pButton (click)="trackFedexShipment(d?.trackingNo)" label="Track Order"
                            style="width: 100px"></button>
                    </span></div>
                <div class="p-col-12 p-md-12" *ngIf="d?.trackingLink && d?.trackingLink == 'UPS' && d?.statusId == '3'">
                    <span>
                        <p>Delivery Status : Voided</p>
                    </span>
                </div>
                <div *ngIf="d?.statusId == '1' && d?.deliveryStatus != 'delivered'" class="p-col-12 p-md-12 pointer"
                    (click)="viewLabelPdf(d)">
                    <p>View Label</p>
                </div>
                <div class="p-col-12 p-md-12" *ngIf="d?.trackingLink && d?.trackingLink == 'UPS' && d?.statusId == '1'">
                    <span>
                        <p>Delivery Status : {{ shipMessage }}</p>
                        <button type="button" pButton (click)="trackUpsShipment(d?.trackingNo)" label="Track Order"
                            style="width: 100px"></button>
                    </span>
                </div>
                <br />
            </div>
            <br />
        </div>


        <!--Custom section and fields-->
        <p-tabView class="no-padding">
            <p-tabPanel header="{{getSectionName('labels_customerreturn_other1')}}"
                *ngIf="customFields?.other1_item?.length>0">
                <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                    [customFieldData]="customFields.other1_item">
                </app-custom-attribute-overview>
            </p-tabPanel>
            <p-tabPanel header="{{getSectionName('labels_customerreturn_other2')}}"
                *ngIf="customFields?.other2_item?.length>0">
                <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                    [customFieldData]="customFields.other2_item">
                </app-custom-attribute-overview>
            </p-tabPanel>
            <p-tabPanel header="{{getSectionName('labels_customerreturn_other3')}}"
                *ngIf="customFields?.other3_item?.length>0">
                <app-custom-attribute-overview [fieldType]="fieldTypes.FIELD"
                    [customFieldData]="customFields.other3_item">
                </app-custom-attribute-overview>
            </p-tabPanel>
        </p-tabView>




        <!--all activity logs-->
        <div class="p-pt-3">
            <app-lion-shared-activities [objectId]="selectedId"> </app-lion-shared-activities>
        </div>
    </p-tabPanel>

    <p-tabPanel [header]="TabHeaderConst.ImpactsOnGL" *ngIf="glTabPermission">
        <app-inventory-impacts-gl [selectedId]="selectedId" [objectTypeId]="transactionTypeIds.CustomerRMA" [callApi]="glApiCall"></app-inventory-impacts-gl>
    </p-tabPanel>
</p-tabView>

<p-dialog [(visible)]="displayStageChange" [modal]="true" [responsive]="true" [closable]="false"
    [style]="{ width: '60vw' }" [baseZIndex]="9999">
    <ng-template pTemplate="header">
        <div style="display: flex; justify-content: space-between; width: 100%;">
            <h5 class="p-mb-0"> Change Stage </h5>
            <div style="display: flex; align-items: center;">
                <div class="p-ml-6">
                    <strong [ngClass]="'status-open'" *ngIf="statementMessege">{{statementMessege}}</strong>
                </div>
            </div>
            <button pButton (click)="editRMA()" class="p-button-text p-button-rounded" *ngIf="!isEdit"
                style="margin-left: auto;" icon="pi pi-pencil"></button>
        </div>
        <button pButton pRipple type="button" icon="pi pi-times"
            class="p-button-rounded p-dialog-header-icon p-dialog-header-close" (click)="cancleStage()"></button>
    </ng-template>
    <div class="card">
        <div class="p-grid" *ngIf="isEdit">
            <div class="p-col-12 p-md-6">
                <label>{{requestTypeLabel}}</label>
                <p-dropdown placeholder="RMA Type" [options]="allRMATypes" appendTo="body" optionLabel="name"
                    [(ngModel)]="selectedRMAType"></p-dropdown>
            </div>
            <div class="p-col-12 p-md-6">
                <label>{{returnReasonLabel}}</label>
                <p-dropdown [options]="allReasons" placeholder="Select a Reason" appendTo="body" optionLabel="name"
                    [showClear]="true" [(ngModel)]="selectedReason"></p-dropdown>
            </div>
        </div>
        <div class="p-grid" *ngIf="!isEdit">
            <div class="p-col-4 p-md-2">
                <div><strong>{{requestTypeLabel}}:</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{customerReturnDetails?.requestType}}</div>
            </div>
            <div class="p-col-4 p-md-2">
                <div><strong>{{returnReasonLabel}}</strong></div>
            </div>
            <div class="p-col-8 p-md-4">
                <div>{{customerReturnDetails?.rmaReason}}</div>
            </div>
        </div>
    </div>
    <div class="header">
        <h5>History</h5>
    </div>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-6" style="border-right: 1px solid #ddd;">
                <ng-container *ngFor="let rmaComment of rmaComments">
                    <p-card class="comment-card">
                        <h6 class="p-mb-1" style="display: inline-block;">
                            {{rmaComment.userName}}
                        </h6>
                        <span class="p-ml-4">
                            <span>{{rmaComment.date | date: 'MM/dd/yyyy'}}</span>
                        </span>
                        <h6 class="p-mb-1" style="float: right;"
                            [ngStyle]="rmaComment.isApproved ? {'color': '#689f38'} : {'color': '#22c55e'}">
                            {{rmaComment.stage}}
                        </h6>
                        <p [innerHTML]="rmaComment.comment" style="word-break: break-all; white-space: pre-line;"
                            class="p-mb-0"></p>
                        <img class="rma-attachment" [src]="rmaComment.attachmentUrl" />
                        <!-- <p-image 
                            src="{{rmaComment.attachmentUrl}}"
                            [preview]="true" 
                            alt="RMA comment attachment">
                        </p-image> -->
                    </p-card>
                </ng-container>
            </div>
            <div class="p-col-6">
                <textarea rows="5" cols="30" [(ngModel)]="stageComment" pInputTextarea autoResize="autoResize"
                    placeholder="Comments..." style="min-height: 100px;"></textarea>
                <div class="p-grid">
                    <div class="p-col-2">
                        <p-fileUpload #stageAttachment mode="basic" name="demo[]" accept="image/*" maxFileSize="1000000"
                            [auto]="false" [customUpload]="true" (onSelect)="saveSelectedAttachments($event)"
                            chooseLabel="Choose" [chooseIcon]="'fa fa-paperclip'">
                        </p-fileUpload>
                    </div>
                    <!-- <div class="p-col-10">
                        <div class="p-mt-2">
                            <ng-container *ngFor="let profileImg of tempAttachment; let i = index;">
                                <a target="_blank" href="{{profileImg.url}}">{{ profileImg.name }}
                                    <span *ngIf="tempAttachment.length>1 && i !== tempAttachment.length-1">, </span>
                                </a>
                            </ng-container>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancleStage()" label="Cancel" class="p-button-secondary"></button>
        <button *ngIf="!showApproveOption" [disabled]="!!statementMessege" pButton pRipple type="button" (click)="saveStage()" label="Save"
            class="p-button-label"></button>
        <button *ngIf="showApproveOption" [disabled]="!!statementMessege" pButton pRipple type="button" (click)="saveStage('decline')" label="Decline"
            class="p-button-danger"></button>
        <button *ngIf="showApproveOption" [disabled]="!!statementMessege" pButton pRipple type="button" (click)="saveStage('approve')" label="Approve"
            class="p-button-label"></button>
    </p-footer>
</p-dialog>
<!-- closing statement -->
<div *ngIf="rmaStages && closingDate">
    <app-closing-statement-validation [isClosingDate]="closingDate" [moduleName]="'CustomerRMA'" (isClosingStatementDate)="isClosingStatementDate($event)"></app-closing-statement-validation>
 </div>

<!-- Tracking Information -->
<p-dialog header="Tracking Information" [(visible)]="displayScanInfo" [modal]="true" [responsive]="true"
    [closable]="false" [style]="{ width: '45vw' }">
    <div class="card">
        <div class="p-field p-formgrid p-grid">
            <p-table [value]="nameLists" class="w-100" [lazy]="true" [paginator]="true" [first]="first"
                [totalRecords]="totalTBRecord" [rows]="pageSize" [showCurrentPageReport]="true"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                [rowsPerPageOptions]="rowsPerPageTB" (onPage)="loadSerialsLazy($event)">
                <ng-template pTemplate="header">
                    <tr>
                        <th id="lot"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'lotChecked',productSerialSettings)">
                            {{utilityServiceObj.displayName('lotChecked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('lotChecked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('lotChecked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="revision"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'revisionChecked',productSerialSettings)">
                            {{utilityServiceObj.displayName('revisionChecked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('revisionChecked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('revisionChecked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="expiration"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'expirationChecked',productSerialSettings)">
                            {{utilityServiceObj.displayName('expirationChecked',trackingOptions,'label')}}</th>
                        <th id="serialNo"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serializedChecked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serializedChecked',trackingOptions,'label')}}</th>
                        <th id="serialNo2"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial2Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial2Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial2Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial2Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo3"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial3Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial3Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial3Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial3Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo4"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial4Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial4Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial4Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial4Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo5"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial5Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial5Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial5Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial5Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo6"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial6Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial6Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial6Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial6Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo7"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial7Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial7Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial7Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial7Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo8"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial8Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial8Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial8Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial8Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo9"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial9Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial9Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial9Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial9Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo10"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial10Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial10Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial10Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial10Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo11"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial11Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial11Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial11Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial11Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo12"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial12Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial12Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial12Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial12Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo13"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial13Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial13Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial13Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial13Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo14"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial14Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial14Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial14Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial14Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo15"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial15Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial15Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial15Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial15Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                        <th id="serialNo16"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial16Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial16Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial16Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial16Checked',trackingOptions,'currency')}})
                                </span>
                            </ng-container>
                        </th>
                        <th id="serialNo17"
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial17Checked',productSerialSettings)">
                            {{utilityServiceObj.displayName('serial17Checked',trackingOptions,'label')}}
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial17Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType === 'Percentage'">(%)</span>
                                <span
                                    *ngIf="controlType === 'Currency'">({{utilityServiceObj.displayName('serial17Checked',trackingOptions,'currency')}})</span>
                            </ng-container>
                        </th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                    <tr>
                        <td
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'lotChecked',productSerialSettings)">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('lotChecked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.lotNo }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.lotNo && product.lotNo |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'revisionChecked',productSerialSettings)">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('revisionChecked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.revisionNo }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.revisionNo &&
                                    product.revisionNO |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td
                            *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'expirationChecked',productSerialSettings)">
                            {{
                            product.expiration | date: "MM/dd/yyyy" }} </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serializedChecked',productSerialSettings)"
                            style="word-break:break-all;">
                            {{product.serialNo}}
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial2Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial2Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo2 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo2 &&
                                    product.serialNo2 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial3Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial3Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo3 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo3 &&
                                    product.serialNo3 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial4Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial4Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo4 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo4 &&
                                    product.serialNo4 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial5Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial5Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo5 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo5 &&
                                    product.serialNo5 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial6Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial6Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo6 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo6 &&
                                    product.serialNo6 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial7Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial7Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo7 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo7 &&
                                    product.serialNo7 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial8Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial8Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo8 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo8 &&
                                    product.serialNo8 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial9Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial9Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo9 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo9 &&
                                    product.serialNo9 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial10Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial10Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo10 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo10 &&
                                    product.serialNo10 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial11Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial11Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo11 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo11 &&
                                    product.serialNo11 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial12Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial12Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo12 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo12 &&
                                    product.serialNo12 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial13Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial13Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo13 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo13 &&
                                    product.serialNo13 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial14Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial14Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo14 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo14 &&
                                    product.serialNo14 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial15Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial15Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo15 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo15 &&
                                    product.serialNo15 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial16Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial16Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo16 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo16 &&
                                    product.serialNo16 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                        <td *ngIf="utilityServiceObj.showTrackingOption(trackingOptions,'serial17Checked',productSerialSettings)"
                            style="word-break: break-all">
                            <ng-container
                                *ngIf="utilityServiceObj.displayName('serial17Checked',trackingOptions,'control') as controlType">
                                <span *ngIf="controlType !== 'DatePicker'">{{ product.serialNo17 }}</span>
                                <span *ngIf="controlType === 'DatePicker'">{{ product.serialNo17 &&
                                    product.serialNo17 |
                                    date:
                                    'MM/dd/yyyy' }}</span>
                            </ng-container>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayScanInfo = false" label="Cancel"
            class="p-button-secondary"></button>
    </p-footer>
</p-dialog>


<!--Shipment dialog-->
<!-- <p-dialog [(visible)]="displayShipmentDialog" [style]="{ width: '60vw' }" (onHide)="onShipmentDialogClose()">
    <ng-container *ngIf="isVisibleCarrier">
        <div class="header">
            <div class="p-grid">
                <div class="p-col-12 p-md-6 p-pb-0">
                    <p-dropdown [options]="shippingCarriers" appendTo="body" optionLabel="name" dataKey="id" [(ngModel)]="selectedCarrier" [ngModelOptions]="{ standalone: true }" (onChange)="onChangeCarrier()"> </p-dropdown>
                </div>
            </div>
        </div>
        <h4 class="p-text-center p-my-3">{{ selectedCarrier?.name }}</h4>
    </ng-container>
    <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'easypost'">
        <app-easypost-shipment [displayAddPackage]="displayShipmentDialog" [detailsObj]="customerReturnDetails" [selectedCarrier]="selectedCarrier" [channel]="soChannel.CUSTOMER_RETURNS" (onLabelCreate)="createLabel($event)" (onClose)="onShipmentDialogClose()" (onStepChange)="onStepChange($event)"></app-easypost-shipment>
    </div>
    <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'fedex'">
        <app-fedex-shipment [detailsObj]="customerReturnDetails" [channel]="soChannel.CUSTOMER_RETURNS" [vendorFedexInfo]="vendorFedexInfo" [selectedCarrier]="selectedCarrier" [fedexAccountInfo]="fedexAccountInfo" [allFedexAccounts]="allFedexAccounts" [allShippingMethods]="allShippingMethods" [displayAddPackage]="displayShipmentDialog" (onFedexLabelCreate)="createFedexLabel($event)" (onClose)="onShipmentDialogClose()" (onStepChange)="onStepChange($event)"></app-fedex-shipment>
    </div>
    <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'ups'">
        <app-ups-shipment [detailsObj]="customerReturnDetails" [channel]="soChannel.CUSTOMER_RETURNS" [vendorUpsInfo]="vendorUpsInfo" [selectedCarrier]="selectedCarrier" [fedexAccountInfo]="fedexAccountInfo" [allUpsAccounts]="allUpsAccounts" [allShippingMethods]="allShippingMethods" [displayAddPackage]="displayShipmentDialog" (onSuccessfullUpsShipment)="onSuccessfullUpsShipment($event)" (onClose)="onShipmentDialogClose()" (onStepChange)="onStepChange($event)"></app-ups-shipment>
    </div>
</p-dialog> -->
<p-dialog [(visible)]="displayShipmentDialog" [style]="{ width: '70vw' }" (onHide)="onShipmentDialogClose()"
    [blockScroll]="true" [closable]="false">
    <ng-template pTemplate="header">
        <ng-container *ngIf="isVisibleCarrier">
            <div class="header p-grid w-100">
                <div class="p-col-4">
                    <p-dropdown [options]="shippingCarriers" appendTo="body" optionLabel="name" dataKey="id"
                        [(ngModel)]="selectedCarrier" [ngModelOptions]="{ standalone: true }"
                        (onChange)="onChangeCarrier()"> </p-dropdown>
                </div>
                <div class="p-col-4">
                    <ng-container
                        *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'fedex'">
                        <p-dropdown [options]="allFedexAccounts" dataKey="id" optionLabel="name" filterBy="name"
                            placeholder="Select an account" [(ngModel)]="selectedFedexAcc"
                            [ngModelOptions]="{ standalone: true }"></p-dropdown>
                    </ng-container>

                </div>
                <div class="p-col-4 p-d-flex" style="flex-direction: row-reverse;">
                    <button pButton pRipple type="button" icon="pi pi-times" (click)="onShipmentDialogClose()"
                        class="p-button-rounded p-dialog-header-icon p-dialog-header-close"></button>
                </div>
            </div>
        </ng-container>
    </ng-template>

    <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'easypost'">
        <app-easypost-shipment [displayAddPackage]="displayShipmentDialog" [detailsObj]="soDetails"
            [selectedCarrier]="selectedCarrier" [channel]="channel" (onLabelCreate)="createLabel($event)"
            (onClose)="onShipmentDialogClose()" (onStepChange)="onStepChange($event)"></app-easypost-shipment>
    </div>
    <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'fedex'">
        <app-fedex-shipment [detailsObj]="soDetails" [channel]="channel" [vendorFedexInfo]="vendorFedexInfo"
            [selectedCarrier]="selectedCarrier" [fedexAccountInfo]="fedexAccountInfo"
            [allFedexAccounts]="allFedexAccounts" [selectedFedexAcc]="selectedFedexAcc"
            [allShippingMethods]="allShippingMethods" [displayAddPackage]="displayShipmentDialog"
            (onFedexLabelCreate)="createFedexLabel($event)" (onClose)="onShipmentDialogClose()"
            (onStepChange)="onStepChange($event)"></app-fedex-shipment>
    </div>
    <div *ngIf="selectedCarrier && selectedCarrier.name && selectedCarrier.name.toLowerCase() == 'ups'">
        <app-ups-shipment [detailsObj]="soDetails" [channel]="channel" [vendorUpsInfo]="vendorUpsInfo"
            [selectedCarrier]="selectedCarrier" [fedexAccountInfo]="fedexAccountInfo" [allUpsAccounts]="allUpsAccounts"
            [allShippingMethods]="allShippingMethods" [displayAddPackage]="displayShipmentDialog"
            (onSuccessfullUpsShipment)="onSuccessfullUpsShipment($event)" (onClose)="onShipmentDialogClose()"
            (onStepChange)="onStepChange($event)"></app-ups-shipment>
    </div>
</p-dialog>